export const getRightYear = (year: string) => {
  if (year.startsWith("0") || year.startsWith("1")) {
    return `20${year}`;
  } else {
    return `19${year}`;
  }
};
